import { EventSourcePolyfill } from 'event-source-polyfill';

// EventSource Manager for handling multiple concurrent connections
class EventSourceManager {
  constructor() {
    this.connections = new Map(); // Map of connectionId -> EventSource
    this.connectionCounter = 0;
  }

  // Create a new connection with a unique ID
  createConnection(url, options, connectionType) {
    console.log('createConnection type:', connectionType);
    // Only close previous connection of the SAME type
    this.closeConnectionByType(connectionType);

    const connectionId = `${connectionType}_${++this.connectionCounter}`;
    const eventSource = new EventSourcePolyfill(url, {
      ...options,
      heartbeatTimeout: 1200000, // 20 minutes
    });

    this.connections.set(connectionId, {
      eventSource,
      type: connectionType,
      url,
      createdAt: Date.now()
    });

    console.log(`Created EventSource connection: ${connectionId} (type: ${connectionType})`);
    return { connectionId, eventSource };
  }

  // Close a specific connection by ID
  closeConnection(connectionId) {
    const connection = this.connections.get(connectionId);
    if (connection) {
      connection.eventSource.close();
      this.connections.delete(connectionId);
      console.log(`Closed EventSource connection: ${connectionId} (type: ${connection.type})`);
    }
  }

  // Close all connections of a specific type
  closeConnectionByType(type) {
    console.log('closeConnectionByType type:', type);
    for (const [connectionId, connection] of this.connections.entries()) {
      console.log('Comparing', connection.type, 'with', type);
      if (connection.type === type) {
        this.closeConnection(connectionId);
      }
    }
  }

  // Close all connections
  closeAllConnections() {
    for (const [connectionId] of this.connections.entries()) {
      this.closeConnection(connectionId);
    }
  }

  // Get connection by ID
  getConnection(connectionId) {
    return this.connections.get(connectionId);
  }

  // Get all active connections
  getActiveConnections() {
    return Array.from(this.connections.keys());
  }

  // Check if a connection type is active
  isConnectionTypeActive(type) {
    return Array.from(this.connections.values()).some(conn => conn.type === type);
  }

  // Debug method to log all active connections
  debugConnections() {
    console.log('=== EventSource Manager Debug ===');
    console.log(`Total active connections: ${this.connections.size}`);
    for (const [connectionId, connection] of this.connections.entries()) {
      console.log(`- ${connectionId}: ${connection.type} (${connection.url})`);
    }
    console.log('================================');
  }

  // Get connection info for a specific type
  getConnectionInfo(type) {
    const connections = Array.from(this.connections.entries())
      .filter(([_, connection]) => connection.type === type);
    return connections.map(([id, connection]) => ({
      id,
      type: connection.type,
      url: connection.url,
      createdAt: connection.createdAt
    }));
  }
}

// Create a singleton instance
const eventSourceManager = new EventSourceManager();

export default eventSourceManager; 